export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w@3x.8b5d13b3.webp";